import type { FormattedPeriod } from '@/utils/helpers/format-period';

import formatDate from '@/utils/helpers/format-date';

export type TimeRange = {
  timeRange: string;
  endDateStr: string;
  isSameDay: boolean;
};

export type DateGroup = {
  dateStr: string;
  dateObj: Date;
  timeRanges: TimeRange[];
};

export const groupPeriodsBySameDate = (periods: FormattedPeriod[]): DateGroup[] => {
  const map = new Map<string, DateGroup>();

  periods.forEach(({ startObj, endObj, startTime, endTime }) => {
    const dateStr = formatDate(startObj, true);
    const endDateStr = formatDate(endObj, true);
    const isSameDay = dateStr === endDateStr;

    const timeRange: TimeRange = {
      timeRange: `${startTime} - ${endTime}`,
      endDateStr,
      isSameDay,
    };

    if (map.has(dateStr)) {
      map.get(dateStr)!.timeRanges.push(timeRange);
    } else {
      map.set(dateStr, { dateStr, dateObj: startObj, timeRanges: [timeRange] });
    }
  });

  return Array.from(map.values());
};
